<!-- 信用卡資料 -->
<template>
  <section v-if="isShow">
    <h2
      :class="$style.listTitle"
      class="card__title card__title--small"
    >
      定期定額信用卡資料
    </h2>
    <ul
      v-if="recurringData"
      class="list"
    >
      <li
        v-if="recurringData.cardNo"
        class="list__item"
      >
        <span class="title">信用卡號</span>
        <span class="data">{{ recurringData.cardNo }}</span>
      </li>
      <li
        v-if="recurringData.cardExpire"
        class="list__item"
      >
        <span class="title">信用卡到期年月</span>
        <span class="data">{{ recurringData.cardExpire }}</span>
      </li>
      <li
        v-if="recurringData.amount"
        class="list__item"
      >
        <span class="title">每期扣款金額</span>
        <span class="data">{{ recurringData.amount }}</span>
      </li>
      <li
        v-if="recurringData.nextPaymentDate"
        class="list__item"
      >
        <span class="title">下次扣款日期</span>
        <span class="data">{{ recurringData.nextPaymentDate }}</span>
      </li>
    </ul>
  </section>
</template>

<script>
export default {
  props: {
    currentTab: {
      type: String,
      default: '',
    },
    recurringData: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    isShow() {
      return this.currentTab === 'cardInfo';
    },
  },
};
</script>

<style lang="scss" module>
.listTitle {
  font-weight: 500;
  border-bottom: 1px solid #d8d8d8;
  margin-top: 34px;
  padding-bottom: 1em;
}
</style>
